<template>
  <section class="report">
    <template v-if="$store.getters.errorMessageWithQuarter">
      <b-alert class="text-center" variant="primary" show dismissible>
        系統查找失效，請重新輸入搜尋代碼或稍待片刻
      </b-alert>
    </template>
    <template v-else>
      <sheet
        :sheetFields="$store.getters.fieldsOfBalanceSheetsQuarter"
        :sheetData="$store.getters.layerOfBalanceSheetsQuarter"
        :sheetName="'資產負債表_季'"
        :companyName="$store.getters.reportQuarter[0].company_name"
        :stockID="$store.getters.reportQuarter[0].stock_symbol"
      />
      <sheet
        :sheetFields="$store.getters.fieldsOfIncomeStatementsQuarter"
        :sheetData="$store.getters.layerOfIncomeStatementsQuarter"
        :sheetName="'綜合損益表_季'"
        :companyName="$store.getters.reportQuarter[0].company_name"
        :stockID="$store.getters.reportQuarter[0].stock_symbol"
      />
      <sheet
        :sheetFields="$store.getters.fieldsOfCashFlowStatementsQuarter"
        :sheetData="$store.getters.layerOfCashFlowStatementsQuarter"
        :sheetName="'現金流量表_季'"
        :companyName="$store.getters.reportQuarter[0].company_name"
        :stockID="$store.getters.reportQuarter[0].stock_symbol"
      />
    </template>
  </section>
</template>

<script>
import sheet from "@/components/sheet.vue";
export default {
  components: {
    sheet
  }
  // async created() {
  //   await Promise.all([
  //     // this.$store.dispatch("FETCH_LAYER"),
  //     this.$store.dispatch("FETCH_REPORT_QUARTER")
  //   ]);
  // }
};
</script>

<style scoped lang="scss">
::v-deep caption {
  padding-bottom: 0;
}
::v-deep .table-hover tbody tr:hover {
  background-color: #343a40;
  color: #fff;
}
</style>
